import React, { useContext } from "react";
import { CN_USER } from "../../constants";
import { ReactSession } from "react-client-session";
import { toast } from "react-toastify";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import FormContext from "../../context/FormContext";
import { Modal, Box, Typography, Slide } from "@mui/material";
import { getErrorToast } from "../../toast";

const style = {
  position: "relative", // For better centering control
  width: "25vw",
  bgcolor: "background.paper",
  border: "unset",
  borderRadius: "10px",
  boxShadow: 24,
  p: 4,
};

function CN({ row, setClaimRecord }) {
  const username = ReactSession.get("username");
  const { isLoading, setIsLoading } = useContext(FormContext);
  const axiosPrivate = useAxiosPrivate();
  const [messageDisplay, setMessageDisplay] = React.useState(false);
  const [batchList, setBatchList] = React.useState([]);

  const CNHandler = async (id) => {
    setIsLoading(true);
    setMessageDisplay(true);

    const apiToast = toast.loading("API Called!", {
      type: "info",
      theme: "colored",
    });
    try {
      const batch_response = await axiosPrivate.get(
        `/data_entry/invoice-empty/${id}`
      );
      if (batch_response.status === 200) {
        setBatchList(batch_response?.data?.message);
      }
    } catch (err) {
      console.log(err);
    }

    axiosPrivate
      .get(`/dashboard/return-order/${id}`)
      .then((res) => {
        toast.update(apiToast, {
          render: "Return Order created successfully!",
          theme: "colored",
          type: "success",
          isLoading: false,
          autoClose: 1500,
        });
        if (res.status === 200) {
          setClaimRecord((record) =>
            record.map((current) =>
              current.stockists_master_id === id
                ? {
                    ...current,
                    indicator: {
                      ...current.indicator,
                      returnorder: true,
                      cn_response: JSON.stringify(res?.data),
                    },
                  }
                : current
            )
          );
        }
      })
      .catch((err) => {
        console.log(err.response.data.message);
        if (err?.response?.data?.message) {
          // getErrorToast(err.response.data.message);
          toast.update(apiToast, {
            render: err?.response?.data?.message,
            theme: "colored",
            type: "error",
            isLoading: false,
            autoClose: 1500,
          });
        } else {
          toast.update(apiToast, {
            render: "Something went wrong!",
            theme: "colored",
            type: "error",
            isLoading: false,
            autoClose: 1500,
          });
        }
      })
      .finally(() => {
        setIsLoading(false);
        setTimeout(
          () => {
            setMessageDisplay(false);
          },
          batchList.length > 0 ? 5000000 : 2000
        );
      });
  };

  return (
    <>
      {/* {!CN_USER.includes(username) && ( */}
      <button
        onClick={() => CNHandler(row.stockists_master_id)}
        disabled={isLoading}
        className={
          row["indicator"]["returnorder"] === true
            ? "claim__buttion__green"
            : "claim__buttion"
        }
      >
        CN
      </button>
      {/* )} */}
      <CNConform
        open={messageDisplay}
        setOpen={setMessageDisplay}
        batchList={batchList}
      />
    </>
  );
}

const CNConform = ({ open, setOpen, batchList }) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition // Ensure the modal unmounts after the transition ends
      aria-labelledby="upload-modal-title"
      aria-describedby="upload-modal-description"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center", // Centers the modal horizontally and vertically
      }}
    >
      {/* Slide animation wraps the content */}
      <Slide in={open} direction="up">
        <Box sx={style}>
          <Typography
            sx={{ textAlign: "center" }}
            id="upload-modal-title"
            variant="h5"
            component="h5"
          >
            PLEASE PAY ATTENTION: SELLABLE ITEMS WITHOUT AN INVOICE WILL NOT BE
            PUSHED TO SAP
          </Typography>
          {batchList.length > 0 && (
            <small>List of batches without invoice: {batchList.length}</small>
          )}
          <Box
            sx={{
              width: "300px", // Set the width of the box
              maxHeight: "200px", // Set the height of the box
              overflowY: "auto", // Enable vertical scrolling
              border: "1px solid #ccc", // Optional: Add a border for clarity
              borderRadius: "8px", // Optional: Rounded corners
              padding: "8px", // Optional: Padding inside the box
              backgroundColor: "#f9f9f9", // Optional: Background color
            }}
          >
            {batchList.length > 0 ? (
              batchList.map((batch, index) => (
                <Typography
                  key={index}
                  sx={{
                    textAlign: "center",
                    padding: "2px 0", // Add some padding between items
                    borderBottom:
                      batchList.length - 1 !== index
                        ? "1px solid #ddd"
                        : "none", // Optional: Add a divider between items
                  }}
                  variant="h6"
                  component="h6"
                >
                  {batch} at row: {index + 1}
                </Typography>
              ))
            ) : (
              <Typography
                sx={{ textAlign: "center", color: "gray", padding: "12px 0" }}
                variant="body1"
              >
                All Are OK
              </Typography>
            )}
          </Box>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              paddingTop: "3rem",
            }}
          ></div>
        </Box>
      </Slide>
    </Modal>
  );
};

export default CN;
export { CNConform };
